'use client';

import { ReactNode } from 'react';

import { StaggerChildren, StaggeredChild } from '@/blocks/animations/AppearInView';
import { AnimatedText } from '@/blocks/animations/animated-text';
import { CurrencyIcon } from '@/blocks/components/AssetIcon';
import { Container } from '@/blocks/components/Container';
import { CurrencyBadge } from '@/blocks/components/CurrencyBadge';
import { LinkBuyCrypto } from '@/blocks/components/PlatformLink';
import { CenterHeading, Section, VStack } from '@/blocks/components/layout';
import { EventBlockNames } from '@/providers/analytics/types';
import typography from '@/styles/typography.module.scss';

import { getCoins } from '@/app/[lang]/buy-crypto/data';

import styles from './styles.module.scss';

type BuyAssetsBadgesProps = {
  title: ReactNode;
};

export const BuyAssetsBadges = ({ title }: BuyAssetsBadgesProps) => {
  const coins = getCoins();

  return (
    <Section data-event-block-name={EventBlockNames.invest}>
      <Container>
        <VStack>
          <CenterHeading>
            <AnimatedText el={'h2'} className={typography.h2}>
              {title}
            </AnimatedText>
          </CenterHeading>

          <StaggerChildren className={styles.badgesList}>
            {coins.map((ticker) => (
              <StaggeredChild key={ticker}>
                <LinkBuyCrypto data-event-label={ticker.toUpperCase()}>
                  <CurrencyBadge
                    text={ticker.toUpperCase()}
                    icon={<CurrencyIcon currencyName={ticker} />}
                    size={'responsiveXM'}
                  />
                </LinkBuyCrypto>
              </StaggeredChild>
            ))}
          </StaggerChildren>
        </VStack>
      </Container>
    </Section>
  );
};
